import { QueryResult, useQuery } from '@apollo/client';
// Api
import { GET_PUBLIC_CAMPAIGN_COLLAB_ROLES } from 'api/campaignV2/queries';
// Types
import { GetPublicCampaignCollabRoles } from '../api/campaignV2/types/GetPublicCampaignCollabRoles';
// Constants

export const useGetCampaignCollabRoles =
  (): QueryResult<GetPublicCampaignCollabRoles> => {
    return useQuery<GetPublicCampaignCollabRoles>(
      GET_PUBLIC_CAMPAIGN_COLLAB_ROLES
    );
  };
